
export {Ellipsis,
Item,
Pagination,
ClayPaginationWithBasicItems} from '@clayui/pagination';
import __x__ from '@clayui/pagination';export default __x__;